export const titleNodeNameMapping: Record<string, string> = {
  H1: 'first',
  H2: 'second',
  H3: 'third',
  H4: 'fourth',
  H5: 'fifth',
  H6: 'sixth'
}

export const titleOrderNumberMapping: Record<string, number> = {
  first: 1,
  second: 2,
  third: 3,
  fourth: 4,
  fifth: 5,
  sixth: 6
}

export const titleSizeMapping: Record<string, string> = {
  first: 'defaultFirstSize',
  second: 'defaultSecondSize',
  third: 'defaultThirdSize',
  fourth: 'defaultFourthSize',
  fifth: 'defaultFifthSize',
  sixth: 'defaultSixthSize'
}

export const defaultTitleOption = {
  defaultFirstSize: 22,
  defaultSecondSize: 18,
  defaultThirdSize: 16,
  defaultFourthSize: 14,
  defaultFifthSize: 12,
  defaultSixthSize: 11
}
